<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="supplierModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >Supllier goods</small
                >
              </legend>
              <form @submit.prevent="loadsupplierGoods()">
                <div class="row">
                  <input
                    type="hidden"
                    class="supplier_id"
                    :value="Supplier.id"
                  />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn btn-danger btn-flat"
                      data-dismiss="modal"
                    >
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingSuppliergoods"
                    >
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingSuppliergoodsLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">Manage suppliers goods</div>
            <fieldset class="border p-3">
              <div></div>
              <div>
                <div class="suppliersLoader">
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i
                    class="fa fa-spinner fa-spin"
                    style="font-size: 24px; color: blue"
                  ></i
                  >Loading suppliers...
                </div>
                <vue-good-table
                  :columns="columns"
                  :rows="systemSuppliers"
                  :pagination-options="{
                    enabled: true,
                    mode: 'records',
                    perPage: 6,
                    position: 'bottom',
                    perPageDropdown: [3, 7, 9],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'Action'">
                      <button
                        class="btn btn-primary btn-sm btn-rounded"
                        data-toggle="modal"
                        data-target="#supplierModal"
                        @click="viewSuppliergood(props.row.id)"
                      >
                        <i class="fa fa-file-pdf-o"></i> Supplier Goods
                      </button>
                    </span>
                    <span v-else>{{
                      props.formattedRow[props.column.field]
                    }}</span>
                  </template>
                </vue-good-table>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Supplier name",
          field: "supplier_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter supplier",
          },
        },
        {
          label: "Contact person",
          field: "contact_person",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter contact person",
          },
        },
        {
          label: "Phone number",
          field: "phone_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone number",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadSuppliers();
  },
  computed: {
    ...mapGetters(["systemSuppliers", "Supplier"]),
  },
  methods: {
    ...mapActions(["loadSuppliers", "viewSuppliergood", "loadsupplierGoods"]),
  },
};
</script>
<style scoped>
.creatingSuppliergoodsLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/reports/suppliergoods.vue